import { colors } from "healthex-common/colors";
import styled from "styled-components";
export const PopupOverlay = styled.div `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${colors.black_30};
    z-index: 9999;
`;
export const PopupContainer = styled.div `
    background-color: ${colors.white_main};
    border-radius: 8px;
    padding: 8px;
    margin: 16px 12px;
`;
export const PopupImage = styled.img `
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
`;
